export const messageType = {
  auth: '02',
  void: '03',
  sett: '04',
};
